module.exports = __webpack_public_path__ + "static/media/48281738_2308769962531515_8667274304322273280_o.a813bbe1.jpg";